// EXCEPTION DEFINTIONS
// 1915535 --> there are more than 200 accounts returned

export const CUSTOM_EXCEPTIONS = {
  EXCEEDS_ACCOUNTS_MAX: 1915535
};

export const hasCustomError = (error, exception) => {
  const { serviceErrorCode } = error;
  if (!serviceErrorCode) {
    return false;
  }
  return CUSTOM_EXCEPTIONS[exception] === parseInt(serviceErrorCode);
};
